/**
 * Focused authored Žvėrynas study cells west of Žvėrynas Bridge.
 *
 * The Blender buildings provide the reviewed foreground anchors. Remaining
 * modest source footprints in these cells use the matching timber family so
 * unrelated Old Town plaster does not fill the gaps between authored assets.
 */
export const ZVERYNAS_TIMBER_STYLE_TILE_IDS: ReadonlySet<string> =
  new Set(["-6:-1", "-6:-2"]);

export const ZVERYNAS_TIMBER_BACKGROUND_MAXIMUM_SPAN_M = 36;
export const ZVERYNAS_TIMBER_BACKGROUND_MAXIMUM_HEIGHT_M = 9.45;

/**
 * Foreground detail shared by the procedural Žvėrynas background houses.
 * These values echo the authored villa set without claiming exact facade
 * features for an individual source footprint.
 */
export const ZVERYNAS_BACKGROUND_DETAIL_CONFIG = Object.freeze({
  minimumFrontageM: 5.5,
  maximumStreetDistanceM: 45,
  maximumWindowColumns: 7,
  sidingCourseSpacingM: 0.48,
  minimumDoorClearanceM: 1.25,
  dormerSpacingM: 12,
  maximumDormerCount: 2,
});
